import { IoChevronBackCircleOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { IoReturnUpBackOutline } from "react-icons/io5";
import ReactMarkdown from "react-markdown";
import rehypeRaw from 'rehype-raw';
import { useState } from "react";
import faqData from "../data/faqData";
import "../style/ClassicFaq.css";

function Faq() {
  const [openId, setOpenId] = useState(null);
  const navigate = useNavigate();
  
  const toggleFaq = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="faq-container">
      <div className="faq-content">
          <IoReturnUpBackOutline
          className="back-icon top"
          onClick={() => navigate("/")}
          />
        <div className="center-elm">
          <h1 className="h1">Vous avez une question ? Nous avons la réponse !</h1>
          <h2 className="h2">
            Découvrez ici les réponses aux questions les plus fréquentes sur nos logiciels, applications web et mobiles, et services IT.
          </h2>
        <div className="faq-cards">
          {faqData.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div key={faq.id} className={`faq-card animation ${isOpen ? "border-on" : "border-off"}`}>
                <div className="title" onClick={() => toggleFaq(faq.id)}>
                  <h1>{faq.question}</h1>
                  <IoChevronBackCircleOutline
                    className={`more-icon ${isOpen ? "more-icon-up" : "more-icon-down"}`}
                    />
                </div>
                <div className={`${isOpen ? "p-block" : "p-none"} response`}>
                  <ReactMarkdown  
                  rehypePlugins={[rehypeRaw]}
                  >
                      {faq.reponse}
                  </ReactMarkdown>
                </div>
              </div>
            );
          })}
          </div>
        <div className="div-explore">
            <a href="https://jway.ma/" class="explore-btn-mention">Notre Site Web</a>
        </div>
        </div>
      </div>
    </div>
  );
}

export default Faq;
